import { EXPERIMENT_QA_CATEGORIES } from '../constants/experiments';

const getExperiments = state => state.experiments;

export const isExperimentEnabled = (state, name) => getExperiments(state)[name] === 'true';
export const getExperimentValue = (state, name) => getExperiments(state)[name];

export const isQACategoriesExperimentEnabled = state =>
  isExperimentEnabled(state, EXPERIMENT_QA_CATEGORIES);
